import { Store } from 'vuex';

import { AppState } from '@/store';
import { Logger } from '../logger';
import { AxiosInstance, AxiosResponse } from 'axios';
import { CharitableCampaign } from '@/models/donations';
import { ApiService } from '../api/api.service';
import { MUTATIONS } from '@/store/order';
import { AnalyticsService } from '../analytics/analytics.service';

export interface DonationsService {
  getCharitableCampaign(countryCode: string): Promise<CharitableCampaign | null>;
  setCharitableCampaign(donation: CharitableCampaign | null): void;
}

const DONATIONS_BASE_ROUTE = '/donation/v1';

export class AppDonationsService extends ApiService implements DonationsService {
  constructor(store: Store<AppState>, httpClient: AxiosInstance, logger: Logger, protected analytics: AnalyticsService) {
    super(store, httpClient, logger, analytics);
  }

  async getCharitableCampaign(countryCode: string): Promise<CharitableCampaign | null> {
    return this.httpClient
      .get(`${DONATIONS_BASE_ROUTE}/charitablecampaigns/first?countryCode=${countryCode}`)
      .then((d: AxiosResponse<CharitableCampaign>) => d.data)
      .catch(e => this.logAndThrowApiError('getCharitableCampaign', e));
  }

  setCharitableCampaign(donation: CharitableCampaign | null): void {
    this.store.commit(MUTATIONS.SET_CHARITABLE_CAMPAIGN, donation);
  }
}
